export default "__VITE_ASSET__DNaO13vb__"